
/**
 *@param target {Any}
 *@param source {Any}
 *@param fields {Object: Optional} Map of field that we need to check
 * */
function deepEqual(target, source, fields){
    const targetType = typeof target;
    const sourceType = typeof source;

    //check first if they has the same type of data
    if(targetType!== sourceType) return false;

    //typeof return "object' in case of array, Let's check if they are lists
    const isTargetAList = target instanceof Array
    const isSourceAList = source instanceof Array
    if(isTargetAList !== isSourceAList) return false;

    switch (targetType) {
        case "undefined":{return true;}
        case "object": {
            if(isTargetAList)
                return _arrayDeepEqual(target,source,fields);
            const fieldsObject = fields && typeof fields === "object"? fields :source;
            return _objectDeepEqual(target,source,fieldsObject)
        }
        default: return target===source;
    }
}

function _arrayDeepEqual(target, source,fields)
{
    if(target.length !== source.length ) return false;
   return !source.some((item,index)=>!deepEqual(target[index],item,fields))
}

function _objectDeepEqual(target, source,fields)
{

    try {
        //why ?  because typeof of null is object, so, we need to handle the "null" value separately to avoid errors
        if(target == null && source ===null)
            return true
        if(target==null || source == null)
            return false;
        const fieldsList = Object.keys(fields);
    return !fieldsList.some((item)=> !deepEqual(target[item],source[item],fields[item]));
    }catch (e) {
        console.log(target,source,fields, typeof fields)
    }
}


export default deepEqual
